<template>
  <div/>
</template>

<script>
import { mapMutations } from 'vuex';

export default {
  data() {
    return {
      hiddenProp: null,
    };
  },
  created() {
    this.initVisibilityListener();
  },
  methods: {
    ...mapMutations([
      'toggleAppVisibility',
    ]),
    initVisibilityListener() {
      let hidden = null;
      let visibilityChange = null;

      if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
        visibilityChange = 'visibilitychange';
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
        visibilityChange = 'msvisibilitychange';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
        visibilityChange = 'webkitvisibilitychange';
      } else if (typeof document.mozHidden !== 'undefined') {
        hidden = 'mozHidden';
        visibilityChange = 'mozvisibilitychange';
      }

      this.hiddenProp = hidden;
      this.hookVisibilityListener(visibilityChange);
    },
    hookVisibilityListener(event) {
      if (typeof document.addEventListener !== 'undefined' && this.hiddenProp !== null) {
        document.addEventListener(event, this.handleVisibilityChange, false);
      }
    },
    handleVisibilityChange() {
      this.toggleAppVisibility(!document[this.hiddenProp]);
    },
  },
};
</script>
